/**
 * Created by lxlqwo@126.com on 2016/6/13.
 */

String.prototype.endWith = function (s) {
    if (s == null || s == "" || this.length == 0 || s.length > this.length)
        return false;
    if (this.substring(this.length - s.length) == s)
        return true;
    else
        return false;
    return true;
};

String.prototype.startWith = function (s) {
    if (s == null || s == "" || this.length == 0 || s.length > this.length)
        return false;
    if (this.substr(0, s.length) == s)
        return true;
    else
        return false;
    return true;
};

Array.prototype.remove = function (dx) {
    if (isNaN(dx) || dx > this.length) {
        return false;
    }
    for (var i = 0, n = 0; i < this.length; i++) {
        if (this[i] != this[dx]) {
            this[n++] = this[i];
        }
    }
    this.length -= 1;
};

function XChargerWebSocket() {
    var socket = null;
    var onMessage = null;
    var onError = null;
    var pingInterval = null;
    var connectInterval = null;
    var socketQueryPath = null;
    var receiver = null;
    this.serverUrl = "";
    this.XChargerCallJSID = "XChargerCallJSID";
    var pingServer = function () {
        if (!window.WebSocket) {
            return;
        }
        if (socket && socket.readyState == WebSocket.OPEN) {
            socket.send([0x0])
        }
    };

    this.connectServer = function () {
        var server = xChargerWebSocket.serverUrl;
        console.info("begin connect to " + server);
        socket = new WebSocket(server + "/" + socketQueryPath);
        socket.onerror = function (event) {
            if (socket) {
                socket.close();
                socket = null;
            }
        }
        socket.onmessage = function (event) {
            try {
                socket.send(receiver + ":" + event.data);
            } finally {
                onMessage(event.data);
            }
        };
    }

    var loopConnect = function () {
        if (socket) {
            if (socket.readyState && socket.readyState == WebSocket.OPEN) {
                return;
            }
            socket.close();
        }
        xChargerWebSocket.connectServer();
    }

    this.connect = function (receiverId, timestamp, nonce, signature, funcOnMessage, funcOnError) {
        receiver = receiverId;
        socketQueryPath = receiverId + "?timestamp=" + timestamp + "&nonce=" + nonce + "&signature=" + signature;
        onMessage = funcOnMessage;
        onError = funcOnError;
        loopConnect();
        if (!pingInterval) {
            console.log("set pingInterval")
            pingInterval = setInterval(function () {
                pingServer();
            }, 10000);
        }
        if (!connectInterval) {
            console.log("set connectInterval")
            connectInterval = setInterval(function () {
                loopConnect();
            }, 2000);
        }
    }

    this.disconnect = function () {
        if (pingInterval) {
            clearInterval(pingInterval);
        }
        if (connectInterval) {
            clearInterval(connectInterval);
        }
        if (socket) {
            socket.close();
        }
    };
}
var xChargerWebSocket = new XChargerWebSocket();
module.exports = xChargerWebSocket;
